import PropTypes from "prop-types";
import "../../dashboard-cme/dashboard-cme.scss";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

const CMEVacationModal = (props) => {
    const [vacation, setVacation] = useState(props.item.TableVacation ? props.item.TableVacation : null);
    const [pto, setPto] = useState(props.item.TableProtected ? props.item.TableProtected : null);

    useEffect(() => {
        if (props.item.TableVacation) setVacation(props.item.TableVacation);
        if (props.item.TableProtected) setPto(props.item.TableProtected);
    }, [props]);

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            contentClassName="dashboard-modal-styles"
            dialogClassName="dashboard-modal"
            scrollable={true}
        >
            <Modal.Header
                className="dashboard-modal-header"
                closeButton
            >
                <Modal.Title className="dashboard-modal-title ml-4 ">
                    {props.item?.AnalystAssociate}
                    <p className="subDepartmentTitle">Vacation/PTO</p>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="cmeModalBody">
                <div>
                    <div>
                        <div className="vacationsModalHeading">Protected Quarterly Weekend Tracking</div>
                        <table className="CMEDashboard">
                            <thead className="MemberTableColumnHeader cmeHeader">
                                <tr className="tableColumnTitles tableHeader">
                                    {
                                        pto[0]?.Columns?.map((dynamicColumns) => {
                                            return (
                                                <th key={dynamicColumns?.Id} className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                    {dynamicColumns?.Name}
                                                </th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody className="tableBody cmeBody">
                                {pto[0]?.Rows.length > 0 &&
                                    pto[0]?.Rows?.map((row) => {
                                        return (
                                            <tr key={row?.Row}>
                                                {row?.Data?.length > 0 &&
                                                    row?.Data?.map((d) => {
                                                        return (
                                                            <td key={d?.Id} className="col-md-1 col-sm-1 mt-2">
                                                                {d.Value}
                                                            </td>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <div className="vacationsModalHeading">Vacations</div>
                        <table className="CMEDashboard">
                            <thead className="MemberTableColumnHeader cmeHeader">
                                <tr className="tableColumnTitles tableHeader">
                                    {
                                        vacation[0]?.Columns?.map((dynamicColumns) => {
                                            return (
                                                <th key={dynamicColumns?.Id} className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                    {dynamicColumns?.Name}
                                                </th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody className="tableBody cmeBody">
                                {vacation[0]?.Rows.length > 0 &&
                                    vacation[0]?.Rows?.map((row) => {
                                        return (
                                            <tr key={row?.Id}>
                                                {row?.Data?.length > 0 &&
                                                    row?.Data?.map((d) => {
                                                        return (
                                                            <td key={d?.Id} className="col-md-1 col-sm-1 mt-2">
                                                                {d.Value}
                                                            </td>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal.Body>
        </Modal >

    )
};

CMEVacationModal.propTypes = {
    item: PropTypes.shape({
        TableVacation: PropTypes.arrayOf(PropTypes.shape({
            Columns: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired
            })).isRequired,
            Rows: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Row: PropTypes.number.isRequired,
                Data: PropTypes.arrayOf(PropTypes.shape({
                    Id: PropTypes.number.isRequired,
                    Value: PropTypes.string.isRequired
                })).isRequired
            })).isRequired
        })),
        TableProtected: PropTypes.arrayOf(PropTypes.shape({
            Columns: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Name: PropTypes.string.isRequired
            })).isRequired,
            Rows: PropTypes.arrayOf(PropTypes.shape({
                Id: PropTypes.number.isRequired,
                Row: PropTypes.number.isRequired,
                Data: PropTypes.arrayOf(PropTypes.shape({
                    Id: PropTypes.number.isRequired,
                    Value: PropTypes.string.isRequired
                })).isRequired
            })).isRequired
        })),
        AnalystAssociate: PropTypes.string,
    }),
    show: PropTypes.bool,
    onHide: PropTypes.func
};

export default CMEVacationModal;
